import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ReportsService } from "../services/reports.service";

@Component({
  selector: "app-loan-customer-list",
  templateUrl: "./loan-customer-list.component.html",
  styleUrls: ["./loan-customer-list.component.scss"],
})
export class LoanCustomerListComponent implements OnInit {
  [x: string]: any;
  showSpinner: boolean = false;
  dataSource: any;
  FromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  ToDate: any = new Date();
  currentUser: any;
  FyearId: any;
  maxDate: any;
  minDate: any;
  SalesEx: any = "All";
  BranchesList: any = [];
  ProductList: any = [];
  SalesExecutiveData: any = [];
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  private _MasterService;

  DataSource: any = [];
  JsonData: any[] = [];
  SelectBranch: any = "All";
  ProductId: any = "All";
  LoanAccountCategory: any = "All";
  SalesExecutive: any = "All";
  Type: string = "loan_toCustomer";
  SearchCustomerName: string = "";
  SearchLoanNo: string = "";
  displayedColumns: string[] = [];

  readonly GROUP_COLOR_1: string = "#87e5e3";
  readonly GROUP_COLOR_2: string = "#fff7f7";

  allColumns: string[] = [
    "#",
    "LoanAcNo",
    "Loan_Date",
    "Loan_Status",
    "Branch_Name",
    "Product_Name",
    "Application_LoanAmount",
    "SalesExecutive",
    "CollectionExecutive",
    "AC_CustomerType",
    "Customer_Name",
    "Customer_DOB",
    "Customer_Relation",
    "Relation_Name",
    "Is_New_Customer",
    "Address1",
    "DistFromAddress1",
    "Address2",
    "DistFromAddress2",
    "Customer_PhoneNo",
    "Customer_WhatsAppNo",
    "Customer_Email",
    "PAN",
    "PAN_Verification",
    "AAdhar",
    "Aadhaar_Verification",
    "DrivingLicence",
    "VoterId",
    "ElectricityBill",
    "CRC_CreditVisionScore",
    "CRC_PersonalLoanScore",
    "CRC_Remark",
    "FI_Remark",
    "TVR_Remark",
    "Total_Income",
    "Total_Expense",
    "Total_Obligation",
    "AssignTo",
  ];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  AccountingCatDropdown: any;
  losService: any;
  chhead: any = "";
  AccountHeadDropdown: any;
  filteredAccountHead: Observable<any[]>;
  AccountControl = new UntypedFormControl();

  groupColorMap: Map<string, string> = new Map();

  constructor(
    private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,
    private snackBar: MatSnackBar,
    private lmsService: LmsService
  ) {
    this._MasterService = MasterService;
  }

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Loan Customer Details");
    this.route.queryParams.subscribe((params) => {
      this.FyearId = params["fyear"];
      this.lmsService
        .Get_FinancialYear({ Id: this.FyearId })
        .subscribe((res: any) => {
          this.minDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          this.maxDate = new Date(moment(res[0].fyent).format("MM/DD/YYYY"));
          this.FromDate = new Date(moment(res[0].fystart).format("MM/DD/YYYY"));
          if (this.maxDate > new Date() && this.minDate < new Date())
            this.ToDate = new Date();
          else this.ToDate = this.maxDate;
          this.DataSource = null;
        });
    });
    this.updateDisplayedColumns();

    this.getBranchesList();
    this.getProductDropdown();
    this.Get_Loan_Accounting_Category_ForDropdown();
    this.GetSalesExecutive();
    this.getAccounthead();
  }

  DateChange() {
    if (this.FromDate != "" && this.ToDate != "") {
      if (this.FromDate > this.ToDate) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "To Date will be greater than to From Date.",
          ...this.configSuccess,
        });
        this.FromDate = "";
        this.ToDate = "";
      }
    }
  }

  updateDisplayedColumns() {
    const columns = [...this.allColumns];

    const filtered = columns.filter(
      (c) => c !== "LoanAcNo" && c !== "Customer_Name"
    );

    if (this.Type === "loan_toCustomer") {
      this.displayedColumns = [
        "#",
        "LoanAcNo",
        "Customer_Name",
        ...filtered.filter((c) => c !== "#"),
      ];
    } else {
      this.displayedColumns = [
        "#",
        "Customer_Name",
        "LoanAcNo",
        ...filtered.filter((c) => c !== "#"),
      ];
    }
  }

  getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }

  getProductDropdown() {
    this._MasterService
      .GetProductList({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.ProductList = JSON.parse(JSON.stringify(result));
      });
  }

  Get_Loan_Accounting_Category_ForDropdown() {
    this.lmsService
      .Get_Loan_Accounting_Category_ForDropdown({ ProductId: 0 })
      .subscribe((res: any) => {
        this.AccountingCatDropdown = res;
      });
  }

  GetSalesExecutive() {
    this.lmsService
      .Get_Collection_Ex_By_UserId({
        LoginUserId: this.currentUser.userId,
        BranchId: "",
      })
      .subscribe((res) => {
        this.SalesExecutiveData = JSON.parse(JSON.stringify(res));
      });
  }

  onAccountHeadhSelect(event: any) {
    this.dataSource = "";
    this.AccountHead = event.option.value.AccountId;
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.AccountHeadDropdown.filter(
      (option) => option.Account_Name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  displayFn(account: any): string {
    return account && account.Account_Name ? account.Account_Name : "";
  }

  getAccounthead() {
    this.lmsService.Loan_Lending_List().subscribe((res: any) => {
      this.AccountHeadDropdown = res;
      this.AccountHead = res[1].AccountId;
      this.filteredAccountHead = this.AccountControl.valueChanges.pipe(
        startWith(""),
        map((value) =>
          typeof value === "string" ? value : value.Account_Name
        ),
        map((name) =>
          name ? this._filter(name) : this.AccountHeadDropdown.slice()
        )
      );
    });
  }

  groupAndSortData(data: any[]): any[] {
    if (!data || data.length === 0) return [];

    let sortedData = [...data];

    if (this.Type === "loan_toCustomer") {
      sortedData.sort((a, b) => {
        if (a.LoanAcNo < b.LoanAcNo) return -1;
        if (a.LoanAcNo > b.LoanAcNo) return 1;

        return a.Customer_Name.localeCompare(b.Customer_Name);
      });
    } else {
      sortedData.sort((a, b) => {
        const aId = a.CustomerId || 0;
        const bId = b.CustomerId || 0;
        if (aId < bId) return -1;
        if (aId > bId) return 1;

        if (a.LoanAcNo < b.LoanAcNo) return -1;
        if (a.LoanAcNo > b.LoanAcNo) return 1;

        return 0;
      });
    }

    return sortedData;
  }

  assignGroupColors(): void {
    this.groupColorMap.clear();

    if (!this.JsonData || this.JsonData.length === 0) return;

    let currentGroupKey: string | null = null;
    let groupIndex = -1;

    this.JsonData.forEach((row) => {
      const key = this.getGroupKey(row);

      if (key !== currentGroupKey) {
        currentGroupKey = key;
        groupIndex++;
      }

      if (key) {
        const color =
          groupIndex % 2 === 0 ? this.GROUP_COLOR_2 : this.GROUP_COLOR_1;
        this.groupColorMap.set(key, color);
      }
    });
  }

  getGroupKey(row: any): string | null {
    if (this.Type === "loan_toCustomer") {
      return row.LoanAcNo ? `loan_${row.LoanAcNo}` : null;
    } else {
      return row.CustomerId ? `customer_${row.CustomerId}` : null;
    }
  }

  getRowBackgroundColor(row: any): string {
    const groupKey = this.getGroupKey(row);
    return this.groupColorMap.get(groupKey || "") || this.GROUP_COLOR_2;
  }

  getRowStyle(row: any, index: number): any {
    const bgColor = this.getRowBackgroundColor(row);
    return {
      "background-color": bgColor,
      color: "white",
    };
  }

  isStartOfNewGroup(row: any, index: number): boolean {
    if (index === 0) return true;

    if (this.Type === "loan_toCustomer") {
      return row.LoanAcNo !== this.JsonData[index - 1].LoanAcNo;
    } else {
      const currentId = row.CustomerId || 0;
      const previousId = this.JsonData[index - 1].CustomerId || 0;
      return currentId !== previousId;
    }
  }

  isSameGroupAsPrevious(row: any, index: number): boolean {
    if (index === 0) return false;

    if (this.Type === "loan_toCustomer") {
      return row.LoanAcNo === this.JsonData[index - 1].LoanAcNo;
    } else {
      const currentId = row.CustomerId || 0;
      const previousId = this.JsonData[index - 1].CustomerId || 0;
      return currentId === previousId;
    }
  }

  isEndOfGroup(row: any, index: number): boolean {
    if (index === this.JsonData.length - 1) return true;

    if (this.Type === "loan_toCustomer") {
      return row.LoanAcNo !== this.JsonData[index + 1].LoanAcNo;
    } else {
      const currentId = row.CustomerId || 0;
      const nextId = this.JsonData[index + 1].CustomerId || 0;
      return currentId !== nextId;
    }
  }

  getGroupNumber(row: any, index: number): number {
    if (index === 0) return 1;

    let groupCount = 1;
    for (let i = 1; i <= index; i++) {
      if (this.isStartOfNewGroup(this.JsonData[i], i)) {
        groupCount++;
      }
    }

    return groupCount;
  }

  getGroupClass(row: any, index: number): string {
    const groupNum = this.getGroupNumber(row, index);
    return groupNum % 2 === 0 ? "group-even" : "group-odd";
  }

  onSearchLoanCustomerList() {
    this.showSpinner = true;
    this.reportsService
      .Loan_Customer_Details({
        FromDate: this.FromDate,
        ToDate: this.ToDate,
        BranchId: this.SelectBranch == "All" ? 0 : this.SelectBranch,
        ProductId: this.ProductId == "All" ? 0 : this.ProductId,
        LoanAcCategory:
          this.Loan_AccountingCategoryId == "All"
            ? 0
            : this.Loan_AccountingCategoryId,
        SalesExecutive: this.SalesEx == "All" ? 0 : this.SalesEx,
        AssignTo: this.chhead.AccountId == "" ? 0 : this.chhead.AccountId,
        LoanAcNo: this.SearchLoanNo,
        Customer_Name: this.SearchCustomerName,
      })
      .subscribe((res: any) => {
        this.JsonData = this.groupAndSortData(res);
        console.log(
          "Sorted Report Data:",
          this.SearchLoanNo,
          this.SearchCustomerName
        );

        this.assignGroupColors();

        console.log("Grouped Report Data:", this.JsonData);

        this.DataSource = new MatTableDataSource(this.JsonData);
        this.DataSource.paginator = this.paginator;
        this.DataSource.sort = this.sort;

        this.DataSource.sortingDataAccessor = (item: any, property: string) => {
          return item[property];
        };

        this.updateDisplayedColumns();
        this.showSpinner = false;
      });
  }

  onTypeChange() {
    this.SearchCustomerName = "";
    this.SearchLoanNo = "";
    this.groupColorMap.clear();

    if (this.JsonData && this.JsonData.length > 0) {
      // Re-sort based on new Type
      this.JsonData = this.groupAndSortData(this.JsonData);

      // Critical: Re-assign colors after sorting
      this.assignGroupColors();

      // Update data source
      this.DataSource.data = this.JsonData;
      this.updateDisplayedColumns();
    }
  }

  applyFilter(filterValue: string) {
    this.DataSource.filter = filterValue.trim().toLowerCase();
  }

  exportExcel(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "loan-customer-deatils"
    ) as HTMLTableElement;
    const worksheetName = "LOAN CUSTOMER DEATILS";
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    downloadLink.href = uri + base64(format(template, ctx));

    downloadLink.download = worksheetName + ".xls";

    downloadLink.click();
  }
}
